"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalanceInfo = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var useBalanceInfo = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentLevelInfo = (0, swr_hooks_1.usePlayerStatus)().currentLevelInfo;
    var pendingBalance = (0, swr_hooks_1.usePendingDeposits)().data;
    var pendingWithdrawals = (0, swr_hooks_1.usePendingWithdrawals)().data;
    var data = (0, swr_hooks_1.useUser)().data;
    var balance = (0, swr_hooks_1.useBalance)().data;
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var openDeposit = function () {
        return router.push(generateUrlWithLang("/account/wallet/deposit"));
    };
    var openWithdrawal = function () {
        return router.push(generateUrlWithLang("/account/wallet/withdrawal"));
    };
    var sortedBonuses = (0, swr_hooks_1.useBonusesCards)().sortedBonuses;
    var freespins = (0, swr_hooks_1.useFreespinsCards)().freespins;
    var activeFreespins = (0, react_1.useMemo)(function () {
        return freespins.find(function (bonus) { return bonus.status === profile_api_1.FreeRoundStatus.InProgress; });
    }, [freespins]);
    var totalFreespins = (0, react_1.useMemo)(function () {
        return freespins.filter(function (bonus) {
            return bonus.status === profile_api_1.FreeRoundStatus.Active ||
                bonus.status === profile_api_1.FreeRoundStatus.InProgress ||
                bonus.status === profile_api_1.FreeRoundStatus.Pending;
        });
    }, [freespins]);
    var bonusesInQueueCount = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = sortedBonuses.filter(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.Pending; })) === null || _a === void 0 ? void 0 : _a.length;
    }, [sortedBonuses]);
    return {
        t: t,
        currentLevelInfo: currentLevelInfo,
        pendingWithdrawals: pendingWithdrawals,
        data: data,
        balance: balance,
        openDeposit: openDeposit,
        openWithdrawal: openWithdrawal,
        activeFreespins: activeFreespins,
        totalFreespins: totalFreespins,
        bonusesInQueueCount: bonusesInQueueCount,
        pendingBalance: pendingBalance,
    };
};
exports.useBalanceInfo = useBalanceInfo;
